"use strict";
var fails = require("../internals/fails");
var isObject = require("../internals/is-object");
var classof = require("../internals/classof-raw");
var ARRAY_BUFFER_NON_EXTENSIBLE = require("../internals/array-buffer-non-extensible");
var $isExtensible = Object.isExtensible;
var FAILS_ON_PRIMITIVES = fails(function() {
  $isExtensible(1);
});
module.exports = FAILS_ON_PRIMITIVES || ARRAY_BUFFER_NON_EXTENSIBLE ? function isExtensible(it) {
  if (!isObject(it)) return false;
  if (ARRAY_BUFFER_NON_EXTENSIBLE && classof(it) === "ArrayBuffer") return false;
  return $isExtensible ? $isExtensible(it) : true;
} : $isExtensible;
